import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmActionModalComponent } from 'shared/common/confirm-action.service';
import { ControlsModule } from 'shared/modules/controls/controls.module';
import { MaterialModule } from 'shared/modules/material/material.module';

@NgModule({
  declarations: [
    ConfirmActionModalComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule,
    ControlsModule,
  ],
  exports: [
    ConfirmActionModalComponent,
  ],
})
export class ConfirmActionModule {
}
